import { render, staticRenderFns } from "./cardRecord.vue?vue&type=template&id=6806ba7c&scoped=true&"
import script from "./cardRecord.vue?vue&type=script&lang=js&"
export * from "./cardRecord.vue?vue&type=script&lang=js&"
import style0 from "./cardRecord.vue?vue&type=style&index=0&id=6806ba7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806ba7c",
  null
  
)

export default component.exports